import { useContext } from 'react'
import { PassContext } from "../../../pass-context"

import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'

const googleAppLink = () => {

  const { classData, objectData, passType } = useContext(PassContext)

  const appLinkData = passType === "generic" ? objectData.appLinkData : classData.appLinkData

  if (appLinkData?.androidAppLinkInfo || appLinkData?.webAppLinkInfo) {
    let label = getLabel(appLinkData)
    let link = appLinkData.webAppLinkInfo?.appTarget.targetUri.uri

    return (
      <div className="app-link mt-10 p-3 pb-1">
        <a href={link}><OpenInNewOutlinedIcon /> {label}</a>
      </div>
    )
  }
}

export default googleAppLink

const getLabel = appLinkData => {
  if (appLinkData.displayText) return appLinkData.displayText?.defaultValue.value
  if (appLinkData.androidAppLinkInfo) return appLinkData.androidAppLinkInfo.appTarget.packageName
  if (appLinkData.webAppLinkInfo) return appLinkData.webAppLinkInfo.appTarget.targetUri.description
}